'use strict';

import {isInExperienceEditor} from '../../components/Sitecore/Sitecore';

module.exports = function(Handlebars) {
  Handlebars.registerHelper('ExperienceEditor', function() {
    return isInExperienceEditor();
  });

  Handlebars.registerHelper('BeginDivWithBackgroundImage', function(images,options) {
    let sizeHashable = (options.hash.size || '') + '~' + (options.hash.initialMaxWidth || '');
    let image = (images && images[sizeHashable]) || {};
    let attributes = {
      class: ''
    };
    if (typeof options.hash.class !== 'undefined') {
      attributes.class += options.hash.class;
    }
    attributes['data-sizes'] = JSON.stringify(image.sizes);
    attributes['data-images'] = JSON.stringify(image.images);
    if (attributes.class.length) {
      attributes.class += ' ';
    }
    attributes.class += 'js-responsive-bg-image';
    if (options.hash.lazyLoad) {
      if (attributes.class.length) {
        attributes.class += ' ';
      }
      attributes.class += 'js-responsive-bg-image--delayed';
    }
    if (!options.hash.lazyLoad && !isInExperienceEditor()) {
      attributes.style = `background-image: url(${image.src})`;
    }
    // yucko - look for data attributes we need to set in the div
    for (var key in options.hash) {
      if (!key.match(/^data-/)) continue;
      attributes[key] = options.hash[key];
    }
    // munging html <3
    let divStart = '<div';
    for (var key in attributes) {
      divStart += ` ${key}=\'${attributes[key]}\'`;
    }
    divStart += '>';
    return new Handlebars.SafeString(divStart + options.fn(this) + '</div>');
  });

  Handlebars.registerHelper('SitecoreImage',function(images,options) {
    let sizeHashable = (options.hash.size || '') + '~' + (options.hash.initialMaxWidth || '');
    let image = images[sizeHashable] || {};

    // TODO - too much C+P from begin div.  it's not clear what javascript elsewhere does with these things like data-images, -sizes, and -srcset.
    //  both of these helpers should be redone.  asp.net side very confusing.
    let attributes = {};
    if (typeof options.hash.class !== 'undefined') {
      attributes.class = options.hash.class;
    }
    attributes['data-sizes'] = JSON.stringify(image.sizes)
    attributes['data-images'] = JSON.stringify(image.sizes)
    attributes['data-srcset'] = JSON.stringify(image.srcset)
    attributes.src = image.src;
    attributes.alt = image.alt;
    // yucko - look for data attributes we need to set in the div
    for (var key in options.hash) {
      if (!key.match(/^data-/)) continue;
      attributes[key] = options.hash[key];
    }
    // munging html <3
    let imgTag = '<img';
    for (var key in attributes) {
      imgTag += ` ${key}=\'${attributes[key]}\'`;
    }
    imgTag += '>';
    return new Handlebars.SafeString(imgTag);
  });

  Handlebars.registerHelper('ExperienceEditorDataAttribute', function() {
    if (!isInExperienceEditor()) {
      return '';
    }
    return 'data-is-editor-mode="true"';
  });
};



// WEBPACK FOOTER //
// ./assets/js/handlebars-helpers/SitecoreHelpers.js